const PRIVACY_URL = "https://www.periziafirma.it/privacy-policy/";
const COOKIE_URL = "https://www.periziafirma.it/cookie-policy/";

export default function Footer() {
  return (
    <footer className="border-t hairline bg-white mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-8 grid md:grid-cols-4 gap-6 text-sm">
        <div>
          <div className="font-serif text-lg font-semibold">Perizia Ready</div>
          <p className="text-slate-600 mt-2 leading-relaxed">
            Valutazione preliminare della completezza documentale del fascicolo grafologico.
            Non esprime giudizi di autenticità.
          </p>
        </div>
        <div>
          <div className="overline mb-2">Sistema</div>
          <ul className="space-y-1 text-slate-600">
            <li>Indice di preparazione</li>
            <li>Piano delle comparative</li>
            <li>Cronologia del caso</li>
          </ul>
        </div>
        <div>
          <div className="overline mb-2">Note legali</div>
          <ul className="space-y-1 text-slate-600">
            <li>
              <a href={PRIVACY_URL} target="_blank" rel="noreferrer" data-testid="footer-privacy-link"
                className="hover:text-navy underline-offset-4 hover:underline">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href={COOKIE_URL} target="_blank" rel="noreferrer" data-testid="footer-cookie-link"
                className="hover:text-navy underline-offset-4 hover:underline">
                Politica sui cookie
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="overline mb-2">Nota metodologica</div>
          <p className="text-slate-600 leading-relaxed">
            Il software misura la completezza delle informazioni inserite;
            non sostituisce il giudizio tecnico del consulente né il parere del difensore.
          </p>
        </div>
      </div>
      <div className="border-t hairline py-3 text-xs text-slate-500 text-center font-mono space-y-1">
        <div>
          <a href="mailto:info@periziafirma.it" data-testid="footer-email"
             className="hover:text-navy underline-offset-4 hover:underline">
            info@periziafirma.it
          </a>
        </div>
        <div>© {new Date().getFullYear()} PeriziaFirma.it — Perizia Ready · P.IVA <span data-testid="footer-vat">02289250504</span></div>
      </div>
    </footer>
  );
}
